module.exports = __webpack_public_path__ + "img/list.440eea66.png";